import { __getCommonData } from '../../selectors';

export const modalSelector = (state) => __getCommonData(state).modal;
